import type { AxiosInstance } from 'axios';
import type { paths } from '../schema';
import type { RequestOptions } from './types';
import { curry1 } from './utils';

export type Country =
  paths['/api/geography/countries']['get']['responses']['200']['content']['application/json'][number];

export const getCountries = async (
  instance: AxiosInstance,
  options?: RequestOptions
): Promise<Country[]> => {
  const res = await instance.get<Country[]>('/geography/countries', options);

  return res.data;
};

export class GeographyService {
  public getCountries;

  constructor(private instance: AxiosInstance) {
    this.getCountries = curry1(getCountries)(this.instance);
  }
}
